<template>
  <a-config-provider :locale="locale">
    <div id="app" @click="hideModal">
      <transition :name="transitionName">
        <router-view></router-view>
      </transition>
    </div>
  </a-config-provider>
</template>
<script>
import Vue from 'vue'
import { Popup, Button} from 'vant'
import { configList, LoginAddress } from '@/api/user'
import loadJs from "@/assets/loadjs"
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import { getDefaultLanguage,getLocalName } from '@/utils/common'
import {customerList} from "@/api/setting";
import {ethers} from "ethers";
import {getToken, getUser, getUserId, setToken, setUser, setUserId} from "@/utils/auth";
import { initQiabotWidget, isQiabotNewType, QIABOT_NEW_TYPE } from '@/utils/qiabot'
import { normalizeCaptchaEnable } from '@/utils/captcha'

import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import enUS from 'ant-design-vue/lib/locale-provider/en_US';
import zhTW from 'ant-design-vue/lib/locale-provider/zh_TW';
import arEG from 'ant-design-vue/lib/locale-provider/ar_EG';
import esES from 'ant-design-vue/lib/locale-provider/es_ES';
import frFR from 'ant-design-vue/lib/locale-provider/fr_FR';
import idID from 'ant-design-vue/lib/locale-provider/id_ID';
import jaJP from 'ant-design-vue/lib/locale-provider/ja_JP';
import koKR from 'ant-design-vue/lib/locale-provider/ko_KR';
import ptPT from 'ant-design-vue/lib/locale-provider/pt_PT';
import ruRU from 'ant-design-vue/lib/locale-provider/ru_RU';
import thTH from 'ant-design-vue/lib/locale-provider/th_TH';
import heIL from 'ant-design-vue/lib/locale-provider/he_IL';
import trTR from 'ant-design-vue/lib/locale-provider/tr_TR';
import hiIN from 'ant-design-vue/lib/locale-provider/hi_IN';
import viVN from 'ant-design-vue/lib/locale-provider/vi_VN';
import deDE from 'ant-design-vue/lib/locale-provider/de_DE';
import huHU from 'ant-design-vue/lib/locale-provider/hu_HU';
import itIT from 'ant-design-vue/lib/locale-provider/it_IT';
import msMY from 'ant-design-vue/lib/locale-provider/ms_MY';

export default {
  components: {
    Popup,
    Button
  },
  data() {
    return {
      loacleObj: {
        'zh-CN': zhCN, //简体中文
        'zh-TW': zhTW, //繁体中文
        'en': enUS, //英文
        'ar': arEG, //阿拉伯语
        'es': esES, //西班牙语
        'fr': frFR, //法语
        'id': idID, //印尼语
        'ja': jaJP, //日语
        'ko': koKR, //韩语
        'pt': ptPT, //葡萄牙语
        'ru': ruRU, //俄语
        'th': thTH, //泰语
        'he': heIL, //希伯来语
        'tr': trTR, //土耳其语
        'hi': hiIN, //印地语
        'vi': viVN, //越南语
        'de': deDE, //德语
        'nl': enUS, //荷兰语（组件库暂无对应语言包时回退英文）
        'hu': huHU, //匈牙利语
        'it': itIT, //意大利语
        'kk': enUS, //哈萨克斯坦语
        'ms': msMY, //马来语
      },
      locale: zhCN,
      transitionName: '',
      hideKefu: false,
      message: '',
      showMsg: false,
      iconType: '',
      isRunMeiqiaScript: false,
      addr: '',
      balance: 0,
      from: '', // 发送方地址
      recipient: '', // 接收方地址
      amount: '', // 转账金额
      signature: ''
    };
  },
  computed: {
    language(val) {
      return this.$store.state.language
    },
    currencyVal() {
      return this.$store.state.currencyVal
    },
    appName() {
      return this.$store.state.appName
    },
  },
  watch: {
    $route(to, from) {
      if (to.meta.index < from.meta.index) {
        this.transitionName = 'slide-right'
      } else if (to.meta.index > from.meta.index) {
        this.transitionName = 'slide-left'
      }
      let name = this.$route.name
      if (name == 'download') {
        this.hideKefu = true
      }
    },
    currencyVal(val) {
      if (val) {
        Vue.prototype.localCurrency = val
      }
    },
    language(val) {
      this.locale = this.loacleObj[val] || zhCN
    },
    appName(val) {
      // 当 appName 变化时，更新页面标题
      if (val) {
        this.updatePageTitle()
      }
    },
  },
  mounted() {

    if(window.ethereum !== null) {
      // this.ethConnect()
    }
    // if(window.tronWeb !== null) {
    //   this.tronConnect()
    // }
    this.init()
    let locale = localStorage.getItem('locale')
    this.runMeiqiaScript()


    const defaultLanguage = getDefaultLanguage()
    this.i18n.locale = locale ? locale : defaultLanguage
    if (localStorage.getItem('locale') == null) {
        localStorage.setItem('locale', this.i18n.locale)
    }
    const name = getLocalName(this.i18n.locale)
    localStorage.setItem('localeName', name)
    this.$store.state.langName = name

    this.$store.state.language = this.i18n.locale
    this.locale = this.loacleObj[this.i18n.locale] || zhCN

    //左右滑
    this.resetMover()

    //计算字体缩放比例
    let screenWidth =  document.getElementById('app').offsetWidth
    if (screenWidth > 540) {
      screenWidth = 540
    }
    this.$store.state.screenScale = screenWidth / 375

    let leftDom = document.getElementById('safeLeft')
    let rightDom = document.getElementById('safeRight')
    if (leftDom) {
      leftDom.addEventListener('touchstart', (e) => {
        e.preventDefault()
      })
      leftDom.addEventListener('touchmove', (e) => {
        e.preventDefault()
      })
    }
    if (rightDom) {
      rightDom.addEventListener('touchstart', (e) => {
        e.preventDefault()
      })
      rightDom.addEventListener('touchmove', (e) => {
        e.preventDefault()
      })
    }

    let currencyName = localStorage.getItem('localCurrency')
    if (currencyName) {
      this.$store.state.currencyVal = currencyName
    }
  },
  methods: {
    async tronConnect() {
      const res = await tronLink.request({method: 'tron_requestAccounts'})
      console.log("tronConnect")
      if (res.code === 200) {
        this.addr = window.tronWeb.defaultAddress.base58;
        console.log("this.addr");
        console.log(this.addr);
        console.log(window.tronWeb.defaultAddress);

        // Get the message to be signed (You may customize this message)
        const message = this.i18n.t('index.login');
        const hex = Buffer.from(message, 'utf8').toString('hex');
        // const hex = '0x01EF'
        // Sign the message using TronLink

        // Sign the transaction
        const signedTransaction = await tronWeb.trx.sign(hex);

        // Extract the signature from the signed transaction
        // const signature = signedTransaction.signature;
        console.log("signature");
        console.log(signedTransaction);
        // Send the signature and address to the server for verification
        LoginAddress({
          "Signature": signedTransaction,
          "Address": this.addr,
          "Hex": window.tronWeb.defaultAddress.hex,
          "Message": hex,
          "Type":"tron"
        }).then(res => {
          console.log(res);
          // Handle the response from the server as per your requirements
        }).catch(err => {
          console.error("Error sending signature to the server:", err);
          // Handle error if any
        });
      }
    },
    //登录钱包签名
     async ethConnect () {
      if (window.ethereum !== null) {
        if(getToken()){
          return
        }
        //连接浏览器默认的web3钱包
        const provider = new ethers.BrowserProvider(window.ethereum);
        //签名
        const signer = await provider.getSigner();
        //获取签名的地址
        this.addr = await signer.getAddress();
        //获取余额
        this.balance = ethers.formatEther(await provider.getBalance(this.addr));
        const message = this.i18n.t('index.login');
        this.signature = await signer.signMessage(message);
        LoginAddress({
          "Signature": this.signature,
          "Address": this.addr,
          "Message": message,
          "Type":"eth"
        }).then(res => {
          console.log(res)
          setToken(res.data.token)
          setUser(this.addr)
          setUserId(res.data.id)
        })
      };
    },
    insertScript(src, token) {

      // 创建一个新的 <script> 元素
      const script = document.createElement('script');

      // 设置 <script> 的 src 属性为你的文件路径
      script.src = src + "packs/js/sdk.js";

      // 使用 onload 事件处理程序来确保脚本加载完成后执行操作
      script.onload = () => {
        console.log('脚本已加载并可用。');
        window.chatwootSDK.run({
            websiteToken: token,
            baseUrl: src
        });
        let that = this
        that.inter = setInterval(function(){
          if(document.getElementsByClassName("woot-widget-bubble")[0] !== undefined) {
            that.show = true;
            clearInterval(that.inter);
            // window.$chatwoot.toggle('open');
            window.$chatwoot.toggleBubbleVisibility('hide');
          }
        },30);

        // 在这里你可以执行脚本加载后的操作
      };

      // 将 <script> 元素添加到页面的 <head> 中，或者你希望的位置
      document.head.appendChild(script);
    },
    runMeiqiaScript() {
      // if(this.isRunMeiqiaScript) {
      //   return
      // }
      // this.isRunMeiqiaScript = true
      //客服
      customerList().then(res => {
        let that = this
        console.log(res.data.Items)
        // this.kefuList = res.data.Items
        for(var i in res.data.Items) {
          let data = res.data.Items[i]
          if(data.Type === 'meiqia') {
            window.localStorage.setItem('kefuType', 'meiqia')
            console.log("runMeiqiaScript")
            const script = document.createElement('script');
            script.async = true;
            script.charset = 'UTF-8';
            script.src = 'https://static.meiqia.com/dist/meiqia.js';
            document.head.appendChild(script);
            window._MEIQIA = window._MEIQIA || function() {
              (window._MEIQIA.a = window._MEIQIA.a || []).push(arguments);
            };
            _MEIQIA = window._MEIQIA
            console.log("set language en")
            // console.log(data)
            this.kefuUrl = data.Link + '&language=en&metadata={"ID":"' +window.localStorage.WebUserId+ '","email":"'+  window.localStorage.WebUserName+'"}'
            // this.runMeiqiaScript()
            let match = this.kefuUrl.match(/eid=([^&]+)/);
            let eidValue = match ? match[1] : null;
            if(eidValue === null) {
              match = this.kefuUrl.match(/entId=([^&]+)/);
              eidValue = match ? match[1] : null;
            }
            _MEIQIA('entId', eidValue);
            _MEIQIA('language','en')
            _MEIQIA('withoutBtn');
            // window._MEIQIA('showPanel');
            // 获取聊天窗口可见性
            _MEIQIA('getPanelVisibility', function (visibility){
              console.log("getPanelVisibility")
              // if (visibility === 'visible') {
              //   _MEIQIA('hidePanel');
              // }
            });

            //点击关闭按钮后的回调
            _MEIQIA('beforeCloseWindow', function() {
              // 返回
              // that.$router.push({
              //   name: 'index'
              // })
            });
            // 传递顾客信息
            // _MEIQIA('metadata', {
            //   ID: getUserId(), // 美洽默认字段
            //   name: getUser(), // 美洽默认字段
            //   username: getUser(), // 美洽默认字段
            // });
            //点击关闭按钮后的回调
            // _MEIQIA('beforeCloseWindow', function() {
            //   // alert('点击了关闭按钮');
            //   // 返回
            //   that.$router.push({
            //     name: 'index'
            //   })
            // });
          }
          if(data.Type === 'chatwoot') {
            window.localStorage.setItem('kefuType', 'chatwoot')
            // 检查链接是否包含 "/"
            if(!data.Link.includes("/")) {
              // 不包含 "/" 则拼接
              data.Link = data.Link + "/"
            }
            this.insertScript(data.Link, data.Token)
          }
          if(isQiabotNewType(data.Type)) {
            window.localStorage.setItem('kefuType', QIABOT_NEW_TYPE)
            initQiabotWidget(data.Link).catch(error => {
              console.error('qiabot新版初始化失败:', error)
            })
          }

        }

      })
    },
    init() {
      configList().then(res => {
        let data = res
        if(data["promote"] !== undefined){
          this.$store.state.promoteUrl = data.promote.Value
        }
        if(data["language"] !== undefined){
          this.$store.state.language = data.language.Value
        }
        // 语言
        if(data["time_zone"] !== undefined){
          this.$store.state.timeZone = data.time_zone.Value
        }

        if (res && res.__serverDate && !this.$store.state.serverTimeOffsetMs) {
          const serverMs = new Date(res.__serverDate).getTime()
          if (!Number.isNaN(serverMs) && serverMs > 0) {
            this.$store.state.serverTimeOffsetMs = serverMs - Date.now()
          }
        }
        if(data["ios_download"] !== undefined){
          this.$store.state.iosDownloadUrl = data.ios_download.Value
        }
        if(data["android_download"] !== undefined){
          this.$store.state.androidDownloadUrl = data.android_download.Value
        }
        
        // 验证码开关
        if(data["captcha_enable"] !== undefined){
          this.$store.state.captchaEnable = normalizeCaptchaEnable(data.captcha_enable.Value)
        }

        // appName
        // if(data["app_name"] !== undefined){
        //   // this.$store.state.appName = data.app_name.Value
        //   // 立即更新当前页面的 title 以包含站点名称
        //   this.updatePageTitle()
        // }
        // 客服
        // this.$store.state.kefuUrl = data.kefu.Value

      }).catch(() => {
        // 配置(含 time_zone / 服务器时间偏移)拉取失败时有限次重试，
        // 避免长期回退到默认时区/本地时钟（init 仅做幂等的配置赋值，重跑安全）
        if ((this._configRetryCount = (this._configRetryCount || 0) + 1) <= 3) {
          setTimeout(() => this.init(), 3000)
        }
      })

      // //用户信息
      // userInfo().then(res => {
      //   let data = res.data
      //   setUser(data.Email)
      //   setUserId(data.ID)
      //   setUserAvatar(data.Avatar)

      //   this.$store.state.shareCode = data.InviteCode
      // })
    },
    showMsgModal(type) {
      this.iconType = type
      this.message = type == 'success' ? this.successMsg : (type == 'error' ? this.errorMsg : this.warningMsg)
      this.showMsg = true
      if (type == 'success') {
        setTimeout(() => {
          this.cancel()
        }, 2000)
      }
    },
    hideModal() {
      this.$store.state.showMenuModal = false
      this.$store.state.footerClick = ''
    },
    cancel() {
      this.showMsg = false
      this.$store.state.successMsg = ''
      this.$store.state.errorMsg = ''
      this.$store.state.warningMsg = ''
    },
    resetMover() {
      let startX = 0
      let startY = 0
      window.document.addEventListener('touchstart', (e) => {
        startX = e.targetTouches[0].pageX
        startY = e.targetTouches[0].pageY
      })
      window.document.addEventListener('touchmove', (e) => {
        let moveX = e.targetTouches[0].pageX
        let moveY = e.targetTouches[0].pageY
        if (Math.abs(moveX - startX) > Math.abs(moveY - startY)) {//左右滑
          e.preventDefault()
        }
      }, { passive: false })
      //
    },
    updatePageTitle() {
      // 获取当前路由信息并更新页面标题
      let key = this.$route.name
      if (key == 'trade' || key == 'account') {
        let query = this.$route.query
        let type = query.type
        key += type
      }
      let title = this.i18n.t(`pageTitle.${key}`)

      // 获取站点名称并拼接到 title 中
      const appName = this.$store.state.appName
      if (appName) {
        document.title = `${title} - ${appName}`
      } else {
        document.title = title
      }
    }
  }
}
</script>

<style>
/* 设置顶部状态栏的背景颜色 */
/* 在 iOS 14 及以上版本中无效 */
/* 在 iOS 13 及以下版本中生效 */
:root {
  --apple-status-bar-color: #000000;
}

/* 设置顶部状态栏的前景颜色 */
/* 在 iOS 14 及以上版本中生效 */
/* 在 iOS 13 及以下版本中无效 */
@media (prefers-color-scheme: dark) {
  /* 暗色模式 */
  /* 在暗色模式下的前景色 */
  :root {
    --apple-status-bar-style: #ffffff
  }
}
@media (prefers-color-scheme: light) {
  /* 亮色模式 */
  /* 在亮色模式下的前景色 */
  :root {
    --apple-status-bar-style: #000000;
  }
}
</style>
<style lang="less">
/* 页面切换动画效果 */
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  height: 100%;
  will-change: transform;
  transition: all 200ms;
  position: absolute;
  // backface-visibility: hidden;
  // perspective: 1000px;
}
.slide-right-enter,
.slide-right-enter-active {
  animation: bounce-left-in 200ms;
}
.slide-right-leave-active {
  animation: bounce-left-out 200ms;
}
.slide-left-enter,
.slide-left-enter-active {
  animation: bounce-right-in 200ms;
}
.slide-left-leave-active {
  animation: bounce-right-out 200ms;
}

@keyframes bounce-right-in {
  0% {
    transform: translate3d(100%, 0, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes bounce-right-out {
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(-100%, 0, 0);
  }
}
@keyframes bounce-left-in {
  0% {
    transform: translate3d(-100%, 0, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes bounce-left-out {
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(100%, 0, 0);
  }
}
</style>
